import { FC } from 'react'

import { Form } from 'brief-form'
import { PageSectionPrimary } from 'ui/components/Page'

import { QuestionnaireFormProps } from './QuestionnaireFormProps'
import {
  ContinuedReview,
  CurrentSARFilingStatus,
  FollowUpItems,
  PreviousSARFilingStatus,
  RapidMovementOfFunds,
  ReviewAllCheckDebitsForPaymentsWasThere,
  ReviewComments,
  ReviewCreditCardActivityForInternationalWasThere,
  ReviewDebitCardActivityForInternationalWasThere,
  ReviewDepositLog,
  ReviewTheApplicableStateCannabis,
  ReviewTheCashActivity,
  ReviewTheDepositActivityOutState,
  ReviewTheInternationalACHReportWasThere,
  ReviewTheTransactionActivity,
  ReviewWireActivityForTransactionsWireActivity,
  SeeCustomerCommunicationOrAnnualQuestions,
  SignedCompletion
} from './components'
import { ComparePriorAndCurrentPercentage } from './components/ComparePriorAndCurrentPercentage'
import { useQuestionnaireForm } from './useQuestionnaireForm'

export const QuestionnaireForm: FC<QuestionnaireFormProps> = ({ setQuestionnaire, questionnaire }) => {
  const { config, Field } = useQuestionnaireForm(questionnaire, setQuestionnaire)

  return (
    <PageSectionPrimary face="solid" title="Red Flags to Distinguish Priority SARs" anchor="red-flags">
      <Form config={config}>
        <ComparePriorAndCurrentPercentage Field={Field} />
        <ReviewTheCashActivity Field={Field} />
        <RapidMovementOfFunds Field={Field} />
        <ReviewDepositLog Field={Field} />
        <ReviewTheTransactionActivity Field={Field} />
        <SeeCustomerCommunicationOrAnnualQuestions Field={Field} />
        <ReviewTheDepositActivityOutState Field={Field} />
        <ReviewWireActivityForTransactionsWireActivity Field={Field} />
        <ReviewTheInternationalACHReportWasThere Field={Field} />
        <ReviewDebitCardActivityForInternationalWasThere Field={Field} />
        <ReviewCreditCardActivityForInternationalWasThere Field={Field} />
        <ReviewAllCheckDebitsForPaymentsWasThere Field={Field} />
        <ReviewTheApplicableStateCannabis Field={Field} />
        <ContinuedReview Field={Field} />
        <ReviewComments Field={Field} />
        <FollowUpItems Field={Field} />
        <PreviousSARFilingStatus Field={Field} />
        <CurrentSARFilingStatus Field={Field} />
        <SignedCompletion Field={Field} />
      </Form>
    </PageSectionPrimary>
  )
}
